import { render, staticRenderFns } from "./EditarRol.vue?vue&type=template&id=c6d61618&"
import script from "./EditarRol.vue?vue&type=script&lang=js&"
export * from "./EditarRol.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports